import React, {Component} from 'react';
import {Button, Modal} from "react-bootstrap";


class ModalInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
        }
    }

    handleShow() {
        this.setState({
            show: true,
        })
    }

    handleClose() {
        this.setState({
            show: false,
        })
    }

    render() {
        return (
            <>
                <Button variant="outline-info" onClick={this.handleShow.bind(this)}>
                    <i className="fa fa-fw fa-info-circle" aria-hidden="true"></i>
                    Información de descargo
                </Button>

                <Modal show={this.state.show} onHide={this.handleClose.bind(this)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Personaliza tu tarjeta SITU</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            Al personalizar tu tarjeta SITU de forma digital puedes recuperar tu saldo si se te llegase a perder.
                        </p>
                        <p>
                            Llena los siguientes campos y personalízala, recuerda que debes ingresar información verídica para mayor seguridad.
                        </p>

                        <b>Nota de descargo:</b>

                        <p>
                            Al llenar los campos declaras que la información, datos, adjuntos y firma de la presente que serán ingresados en la plataforma SITU son de naturaleza verídica y real, caso contrario se atienen a las consecuencias legales civiles o penales que establece la Ley, que por uso de identidad o documentos falsos pudieran tener a lugar.
                        </p>
                        <p>
                            La información ingresada en este portal solo es de uso del Consorcio de Transportistas "Ciudad de Loja" y de la empresa Kradac para la administración y control de los sistemas tecnológicos implementados en el SITU.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose.bind(this)}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ModalInfo;
